import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { formatAlgoliaHits } from "shared/utils/formatAlgoliaHits";
import { searchThemeTagsIndex } from "../constants";
import { ThemeTag } from "../types";

const THEME_TAGS_KEY = "themeTags";

export const useThemeTagsListQuery = () => {
  return useQuery({
    queryKey: [THEME_TAGS_KEY],
    queryFn: async () => {
      const firstPageResponse = await searchThemeTagsIndex.search<ThemeTag>(
        "",
        {
          hitsPerPage: 1000,
          page: 0,
        },
      );

      let allHits = [...firstPageResponse.hits];
      const { nbPages } = firstPageResponse;

      if (nbPages > 1) {
        const remainingPages = Array.from(
          { length: nbPages - 1 },
          (_, i) => i + 1,
        );

        const additionalResults = await Promise.all(
          remainingPages.map((page) =>
            searchThemeTagsIndex.search<ThemeTag>("", {
              hitsPerPage: 1000,
              page,
            }),
          ),
        );

        additionalResults.forEach((result) => {
          allHits = [...allHits, ...result.hits];
        });
      }

      return formatAlgoliaHits<ThemeTag>(allHits);
    },
  });
};

export const invalidateThemeTagsListQuery = () => {
  return queryClient.invalidateQueries({ queryKey: [THEME_TAGS_KEY] });
};
